import { render, staticRenderFns } from "./your-tour.vue?vue&type=template&id=a2bf3fa6&scoped=true&"
import script from "./your-tour.vue?vue&type=script&lang=js&"
export * from "./your-tour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bf3fa6",
  null
  
)

export default component.exports